module.exports = __webpack_public_path__ + "static/media/dani.33a58d52.jpg";